import { Box, Stack, Skeleton } from '@mui/material';

export default function CandidateRowSkeleton() {
  return (
    <Stack spacing="16px" mb="16px">
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
                <Skeleton width="28px" height="13px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={120}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={149}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
              <Skeleton
                width={120}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
                <Skeleton width="28px" height="13px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={120}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={149}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.border.primaryBlack3}`,
          borderRadius: '6px',
          backgroundColor: theme => theme.palette.background.default,
          px: '16px',
          py: '12px',
          mx: '50px',
        }}
      >
        <Stack spacing="22px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="baseline" spacing="12px">
              <Stack spacing="6px" alignItems="center">
                <Skeleton width="28px" height="16px" />
              </Stack>
              <Stack spacing="6px">
                <Skeleton width="130px" height="16px" />
                <Skeleton width="200px" height="16px" />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing="2px"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Skeleton width="57px" height="13px" />
              <Skeleton width="20px" height="13px" />
              <Skeleton width="20px" height="13px" />
            </Stack>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing="9px"
          >
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={123}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
            </Stack>
            <Stack
              onClick={e => {
                e.stopPropagation();
              }}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Skeleton
                width={68}
                height={32}
                sx={{
                  borderRadius: '43px',
                  backgroundColor: '#F7F7F7',
                }}
              />
              <Skeleton
                width={120}
                height={32}
                sx={{
                  borderRadius: '43px',
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
